module.exports = __webpack_public_path__ + "img/filtered_ear_plugs.3351a68b.jpg";